/**
 * Dashboard subpage paths shared across Finance, Performance, Operations, and Overview.
 */
export const DASHBOARD_DETAIL_HREFS = {
  practiceRevenueOverview: '/dashboard/practice-revenue-overview',
  production: '/dashboard/production?context=finance',
  /** Include `context=overview`; use `buildDashboardDetailHref` with `range`/`date` query params. */
  productionOverview: '/dashboard/production?context=overview',
  financeCollection: '/dashboard/finance-collection',
  financeCollectionPerformance:
    '/dashboard/finance-collection?context=performance',
  financeCollectionRatio: '/dashboard/finance-collection-ratio',
  financeCollectionRatioPerformance:
    '/dashboard/finance-collection-ratio?context=performance',
  collectionPerformance: '/dashboard/collection-performance',
  insuranceClaims: '/dashboard/insurance-claims',
  financeClaims: '/dashboard/finance-claims',
  financeOutstandingBalance: '/dashboard/finance-outstanding-balance',
  insurancePatientCollection: '/dashboard/insurance-patient-collection',
  dentistHygienistProduction: '/dashboard/dentist-hygienist-production',
  financeProductionByDepartment: '/dashboard/finance-production-by-department',
  treatmentAcceptance: '/dashboard/treatment-acceptance',
  diagnosis: '/dashboard/diagnosis',
  treatmentValue: '/dashboard/treatment-value',
  /** Include `context=finance`; use `buildDashboardDetailHref` with `range`/`date` query params. */
  arAging: '/dashboard/ar-aging?context=finance',
  arAgingOverview: '/dashboard/ar-aging?context=overview',
  procedures: '/dashboard/procedures',
  collection: '/dashboard/collection',
  revenueOverview: '/dashboard/revenue-overview',
  financeProductionByProcedure: '/dashboard/finance-production-by-procedure',
  providerUtilization: '/dashboard/provider-utilization?context=performance',
  financeProductionPerProvider: '/dashboard/finance-production-per-provider',
  netHygieneProduction: '/dashboard/net-hygiene-production',
  productionPerHygieneVisit: '/dashboard/production-per-hygiene-visit',
  schedulingPerformance: '/dashboard/scheduling-performance',
  scheduleOperations: '/dashboard/schedule-operations',
  patientsAge: '/dashboard/patients-age',
  patientStatus: '/dashboard/patient-status',
  seatUtilization: '/dashboard/seat-utilization?context=performance',
  clinicalEfficiency: '/dashboard/clinical-efficiency',
  caseAcceptance: '/dashboard/case-acceptance',
  arOver90Day: '/dashboard/ar-over-90-day',
  todayForecast: '/dashboard/forecast',
  providerPerformance: '/dashboard/provider-performance',
  yesterdaysPerformance: '/dashboard/yesterdays-performance',
  leaderboard: '/dashboard/leaderboard',
  yesterdayActuals: '/dashboard/huddle-yesterday-actuals',
  yesterdayPerformance: '/dashboard/huddle-yesterday-performance',
  yesterdayProviderActuals: '/dashboard/huddle-yesterday-provider-actuals',
  yesterdayScheduleAdjustments: '/dashboard/huddle-yesterday-schedule',
  tomorrowForecast: '/dashboard/huddle-tomorrow-forecast',
  tomorrowScheduleAtAGlance: '/dashboard/huddle-tomorrow-schedule',
} as const
